import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import ResumeTailor from "@/pages/ResumeTailor";
import CoverLetter from "@/pages/CoverLetter";
import InterviewPrep from "@/pages/InterviewPrep";
import ThankYouLetter from "@/pages/ThankYouLetter";
import Tracker from "@/pages/Tracker";
import Pricing from "@/pages/Pricing";
import Terms from "@/pages/Terms";
import BillingSuccess from "@/pages/BillingSuccess";
import SavedSearches from "@/pages/SavedSearches";
import Referrals from "@/pages/Referrals";
import SharedResume from "@/pages/SharedResume";
import Watchlist from "@/pages/Watchlist";

function Shell() {
  return (
    <>
      <Navbar />
      <main><Outlet /></main>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Shell />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/:slug" element={<JobDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
              <Route path="/tailor" element={<ProtectedRoute><ResumeTailor /></ProtectedRoute>} />
              <Route path="/cover-letter" element={<ProtectedRoute><CoverLetter /></ProtectedRoute>} />
              <Route path="/interview-prep" element={<ProtectedRoute><InterviewPrep /></ProtectedRoute>} />
              <Route path="/thank-you" element={<ProtectedRoute><ThankYouLetter /></ProtectedRoute>} />
              <Route path="/tracker" element={<ProtectedRoute><Tracker /></ProtectedRoute>} />
              <Route path="/alerts" element={<ProtectedRoute><SavedSearches /></ProtectedRoute>} />
              <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
              <Route path="/watchlist" element={<ProtectedRoute><Watchlist /></ProtectedRoute>} />
              <Route path="/r/:shareId" element={<SharedResume />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
